"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        /**
         * Framework class for the prefix root message data
         * @internal
         */
        var PrefixRootMessage = /** @class */ (function () {
            // tslint:enable:object-literal-sort-keys
            function PrefixRootMessage() {
                var _this = this;
                /**
                 * Defines the keyboard shortcuts bound to the prefix message
                 */
                // tslint:disable:object-literal-sort-keys
                this.Shortcuts = {
                    Enter: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                        Handler: function (evt) {
                            this.ExecuteHyperlink();
                        },
                        ShowToUser: false
                    },
                    Spacebar: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.spacebar },
                        Handler: function (evt) {
                            this.ExecuteHyperlink();
                        },
                        ShowToUser: false
                    }
                };
                this.text = "";
                this.type = $dyn.messaging.MessageType.information;
                this.originType = $dyn.messaging.OriginType.InfoLog;
                this.isMessage = true;
                this.isAlert = false;
                this.isWatchDog = false;
                this.prefixMessages = [];
                this.prefixItemList = [];
                this.prefixSection = {
                    messages: [],
                    prefixItemList: [],
                    prefixItemType: 1,
                    sectionExpanded: $dyn.observable(true),
                    sections: [],
                    sectionTitle: ""
                };
                this.showLink = $dyn.observable(true);
                this.messageCount = $dyn.observable(0);
                this.Value = $dyn.observable();
                this.ActionMessageText = "";
                this.readOnly = true;
                this.maxMessageCount = $dyn.computed(function () {
                    return $dyn.value(_this.messageCount) >= 500;
                });
                this.statusIcon = $dyn.computed(function () {
                    return $dyn.util.enumName(_this.type, $dyn.messaging.MessageType);
                });
                this.ShowPrefixLink = $dyn.computed(function () {
                    return $dyn.value(_this.messageCount) > 1;
                });
                this.ShowActionMessageLink = $dyn.computed(function () {
                    return _this.ShowPrefixLink();
                });
                this.ShowExtraMessageText = $dyn.computed(function () {
                    return _this.ShowPrefixMessageText();
                });
                this.ShowPrefixMessageText = $dyn.computed(function () {
                    return $dyn.value(_this.messageCount) === 1;
                });
                this.messageText = $dyn.computed(function () {
                    var text = "";
                    if (_this.firstMessage) {
                        for (var i = 1; i <= _this.firstMessage.prefixCount; i++) {
                            text = text + _this.firstMessage.prefixParts[i] + " ";
                        }
                    }
                    return text;
                });
                this.ExecuteHyperlink = function () {
                    $dyn.messaging.MessageCenterManager.messageCenterVisible(false);
                    var options = {
                        context: _this,
                        role: "Dialog",
                        templateId: "PrefixMessageSection",
                    };
                    $dyn.shell.createForm(options);
                    var context = $dyn.context(options.targetElement);
                    context.DisplayTarget = $dyn.forms.DisplayTarget.AsidePane;
                    $dyn.shell.open({ form: context });
                };
            }
            /**
             * The keydown event handler.
             * @param event The keydown event
             */
            PrefixRootMessage.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            /**
             * Adds a message to this prefix root - adds it to the proper section in the tree
             * @param { $dyn.messaging.Message } childMessage - the message to add to this prefix message
             * @internal
             */
            PrefixRootMessage.prototype.addPrefixMessage = function (childMessage) {
                if (childMessage.rootPrefix && childMessage.rootPrefix === this.rootPrefix) {
                    // start at the root and match the prefixs
                    var currentSection = this.prefixSection;
                    for (var i = 1; i < childMessage.prefixCount; i++) {
                        var foundSection = false;
                        for (var j = 0; j < $dyn.length(currentSection.sections); j++) {
                            var section = currentSection.sections[j];
                            if (section.sectionTitle === childMessage.prefixParts[i]) {
                                // there is an existing section
                                currentSection = section;
                                foundSection = true;
                            }
                        }
                        if (!foundSection) {
                            // add it to the parent
                            var newSection = {
                                messages: [],
                                prefixItemList: [],
                                prefixItemType: 1,
                                sectionExpanded: $dyn.observable(true),
                                sections: [],
                                sectionTitle: childMessage.prefixParts[i]
                            };
                            currentSection.sections.push(newSection);
                            // add it to the list to bind
                            newSection.prefixItemType = 1;
                            currentSection.prefixItemList.push(newSection);
                            // make it current
                            currentSection = newSection;
                        }
                    }
                    if (this.firstMessage == null) {
                        this.firstMessage = childMessage;
                    }
                    currentSection.messages.push(childMessage);
                    // add it to the item list
                    childMessage.prefixItemType = 2;
                    currentSection.prefixItemList.push(childMessage);
                    this.messageCount(this.messageCount() + 1);
                    if (childMessage.type > this.type) {
                        this.type = childMessage.type;
                    }
                    this.activityId = childMessage.activityId;
                }
            };
            return PrefixRootMessage;
        }());
        messaging.PrefixRootMessage = PrefixRootMessage;
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PrefixRootMessage.js.map
